import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import * as dealerDetailActions from '../actions/dealer-detail-auth.action';
import { AutorizationService } from '../../services/authorization-service';
import * as appDealerDetailActions from '../actions/dealer-detail-auth.action';
@Injectable()
export class AuthenticationEffect {
  constructor(
    private readonly actions$: Actions,
    private readonly dealerFeatureAccessService: AutorizationService
  ) {}
  
  public getDealerData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.LoadDealerAction),
    switchMap((action) => this.dealerFeatureAccessService.getDealerDetails( action.payload.dealerCode
    ).pipe(
      map((response: any) => appDealerDetailActions.LoadDealerSuccessAction({ response })),
      catchError((error) => of(appDealerDetailActions.LoadDealerFailAction({ error })))
    ))
  ));

  
  public getDealerConfig$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.DealerConfigAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.getDealerConfigDetails(action.payload)
        .pipe(map((response) => appDealerDetailActions.DealerConfigSuccessAction({ response })),
          catchError((error) => of(appDealerDetailActions.DealerConfigFailAction({ error })))
        ))
  ));
  
  getUserInfoData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.LoadUserInfoAction),
    switchMap(() =>
      this.dealerFeatureAccessService.loadUserInfo()
      .pipe(map((response: any) => appDealerDetailActions.LoadUserInfoSuccessAction({ response })),
        catchError((error) => of(appDealerDetailActions.LoadUserInfoFailAction({ error })))
      )
    )
  ));
  
  getCreditData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.LoadCreditAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.getCredit(action.payload.regionCode).pipe(
        map((response: any) => appDealerDetailActions.LoadCreditSuccessAction({ response })),
        catchError((error) => of(appDealerDetailActions.LoadCreditFailAction({ error })))
      )
    )
  ));
  
  getCustomViewAndTeamsData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.LoadCustomViewAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.getUserPreferences(action.payload).pipe(
          map((response: any) => appDealerDetailActions.LoadCustomViewSuccessAction({ response })),
          catchError((error) => of(appDealerDetailActions.LoadCustomViewFailAction({ error })))
        )
      )
  ));
  
  getSalesConsultantData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.LoadSalesConsultantAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.getSalesConsultatnt(action.payload).pipe(
        map((response: any) => appDealerDetailActions.LoadSalesConsultantSuccessAction({ response })),
        catchError((error) => of(appDealerDetailActions.LoadSalesConsultantFailAction({ error })))
      )
    )
  ));
  
  updateCustomViewData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.UpdateCustomViewAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.updateCustomView(action.payload).pipe(
        map((data: any) => appDealerDetailActions.LoadCustomViewAction(action)),
        catchError((error) => of(appDealerDetailActions.LoadCustomViewFailAction({ error })))
      )
    )
  ));
  
  updateLogViewData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(dealerDetailActions.UpdateLogViewAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.updateLogView(action.payload).pipe(
        map((data: any) => appDealerDetailActions.LoadCustomViewAction(action)),
        catchError((error) => of(appDealerDetailActions.LoadCustomViewFailAction({ error })))
      )
    )
  ));
  
  updateMyTeamsData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.UpdateMyTeamsAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.updateMyTeams(action.payload).pipe(
        map((data: any) => appDealerDetailActions.LoadCustomViewAction(action)),
        catchError((error) => of(appDealerDetailActions.LoadCustomViewFailAction({ error })))
      )
    )
  ));
  
  updateTheThemeData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(appDealerDetailActions.UpdateTheThemeAction),
    switchMap((action) =>
      this.dealerFeatureAccessService.updateTheTheme(action.payload).pipe(
        map((data: any) => appDealerDetailActions.LoadCustomViewAction(action)),
        catchError((error) => of(appDealerDetailActions.UpdateTheThemeFailureAction({ error })))
      )
    )
  ));
}
